<template>
    <Header></Header>
    <div class="container sub_page _news">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_02"><img src="img/news_left.png" /></i>
                <i class="deco_03 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 _xxxsmall blink_blink1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_06"><img src="img/line_circle.png" /></i>
                <i class="deco_07 _small spin_blink2"><img src="img/b_icon_01.png" /></i>
                <i class="deco_08 _xsmall blink_blink3"><img src="img/b_icon_04.png" /></i>
                <i class="deco_09 _xsmall blink2"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/news_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>자료집</h2>
            </div>
        </section>
        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <a href="" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="감시소식" /></span>
                <router-link to="/archive">자료집</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="글쓰기" /></span>
                <span class="news_title">글쓰기</span>
            </div>

            <div class="sub_page_con_view sign_form con_write">
                <div class="report_con">
                    <ul>
                        <li class="checkbox_wrap">
                            <span class="form_li_tit">제목</span>
                            <input type="text" placeholder="제목을 입력해주세요." v-model="form_state.title" />
                        </li>

                        <li class="file_wrap">
                            <span class="form_li_tit">
                                썸네일
                                <p class="p_info">아래 이미지 영역을 클릭해주세요.</p>
                            </span>
                            <label for="file_file_thumbnail" style="cursor: pointer">
                                <input id="file_file_thumbnail" type="file" placeholder="" accept="image/*" @change="changethumbnail" />
                                <div class="thumbnail_preview">
                                    <img :src="form_state.thumbnail" alt="" @error="CommonUtils.errorImg" />
                                </div>
                            </label>
                            <p class="p_info">50M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                        </li>
                        <li class="file_wrap">
                            <span class="form_li_tit">첨부파일</span>
                            <label for="area_file">
                                <input id="area_file" type="file" placeholder="" multiple @change="handleFiles" />
                                <template v-if="!state.isMobile">
                                    <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                    <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                    <p class="p_info">각 파일은 200MB 이하로 업로드 가능합니다. (최대 5개)</p>
                                </template>
                                <template v-else>
                                    <p class="p_info">각 파일은 200MB 이하로 업로드 가능합니다. (최대 5개)</p>
                                    <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                </template>
                            </label>
                            <div class="file_list">
                                <div class="file" v-for="(item, idx) in form_state.files" :key="idx">
                                    <span class="file_name" @click="downloadFile(item.file, item.fileRealName)">{{ item.fileRealName }}</span>
                                    <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                        <img src="img/close_02.png" alt="" />
                                    </button>
                                </div>

                                <div class="file" v-for="(item, index) in state.fileList" :key="index">
                                    <span class="file_name">{{ item.name }}</span>
                                    <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                        <img src="img/close_02.png" alt="" />
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 하단 업소추가 버튼 클릭시 div.report_con 반복 끝-->
            </div>

            <div class="btn_wrap _default left_right_btn _1_2">
                <button class="common_btn _gray w_130" @click="router.go(-1)">취소</button>
                <button class="common_btn w_130" @click="isShowPreview" v-if="!state.isMobile">미리보기</button>
                <button class="common_btn w_130" @click="save">작성완료</button>
            </div>
            <img src="" alt="" />
        </section>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ModalPreviewForBoard
        v-if="state.isShowPreview"
        :type="'news'"
        :title="form_state.title"
        :content="state.previewModalContent"
        :data="form_state"
        @close="state.isShowPreview = false"
    ></ModalPreviewForBoard>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        userStore,
        onMounted,
        onBeforeMount,
        watch,
        useRoute,
        Header,
        Footer,
        router,
        apiService,
        types,
        ModalDefault,
        ModalPreviewForBoard,
        ref,
        getMessageByCode,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, ModalPreviewForBoard },
        setup() {
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                tab: 1 as number,
                idx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                previewModalContent: "" as string,

                isShowPreview: false as boolean,
                thumbnail: {} as File,
                fileList: [] as File[],

                isAuth: false,
                isMobile: false,
            });

            const form_state = reactive({
                title: "" as string,
                thumbnail: "" as string,
                files: [] as Array<types.ResArchiveFileVOForApi>,
            });
            const header = ref();

            onBeforeMount(() => {
                if (
                    !(
                        user.isLogin() &&
                        (user.userInfo.gubun === 1 ||
                            (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("news") > -1)))
                    )
                ) {
                    state.modalTab = -1;
                    state.modalTitle = "권한 부재";
                    state.modalContent = "권한이 없습니다.";
                    state.isShowModal = true;
                }
            });

            onMounted(async () => {
                state.isAuth = false;
                const idx = Number(route.params.id);
                if (route.params.id) {
                    if (idx && typeof idx === "number" && !isNaN(idx)) {
                        state.idx = idx;

                        if (user.isLogin()) {
                            await getDetail();
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "작성자 아님";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                        }
                    } else {
                        router.back();
                    }

                    state.isMobile = window.innerWidth < 768;
                }
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            const getDetail = async () => {
                const res = await apiService.archive.detail(state.idx);

                if (res.returnCode === 0) {
                    form_state.title = res.data.title;
                    form_state.thumbnail = res.data.thumbnail;
                    form_state.files = res.data.fileList;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const fileRemove = async (fileIdx: number) => {
                if (fileIdx > 0) {
                    const res = await apiService.archive.removeFile(state.idx, fileIdx);
                    if (res.returnCode === 0) {
                        const index = form_state.files.findIndex((item) => item.idx === fileIdx);
                        if (index !== -1) {
                            form_state.files.splice(index, 1);
                        }
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (state.idx > 0 && state.modalTab === -1) router.replace({ name: "ArchiveView", params: { id: state.idx } });
                else if (state.modalTab !== 8) router.replace("/archive");
            };

            const callBackModal = async (param: any) => {
                state.isShowModal = false;
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                state.fileList = files;
                target.value = "";
            };

            const changethumbnail = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일만 업로드할 수 있습니다.";
                    state.isShowModal = true;

                    target.value = "";
                    return;
                }

                state.thumbnail = files[0];
                form_state.thumbnail = URL.createObjectURL(state.thumbnail);
                target.value = "";
            };

            const removethumbnail = async (idxFile?: number) => {
                if (state.idx > 0 && idxFile) {
                    const res = await apiService.archive.removeFile(state.idx, idxFile);
                    if (res.returnCode === 0) {
                        const index = form_state.files.findIndex((item) => item.idx === idxFile);
                        if (index !== -1) {
                            form_state.files.splice(index, 1);
                        }
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = 8;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.thumbnail = {} as File;
                }
            };

            const removeNewFile = (index: number) => {
                state.fileList.splice(index, 1);
            };

            const save = async () => {
                if (
                    !form_state.title ||
                    (!form_state.thumbnail && !state.thumbnail.name) ||
                    (state.fileList.length === 0 && form_state.files.length === 0)
                ) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "제목, 썸네일, 첨부파일을 확인해주세요.";
                    state.isShowModal = true;
                }
                if (state.fileList.length > 5) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "첨부파일은 최대 5개까지 첨부 가능합니다.";
                    state.isShowModal = true;
                } else {
                    if (!(state.idx > 0)) add();
                    else modify();
                }
            };

            const add = async () => {
                const param: types.ReqBoardForArchive = {
                    title: form_state.title,
                    file_thumbnail: state.thumbnail,
                    file: state.fileList,
                };
                const res = await apiService.archive.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const modify = async () => {
                const param: types.ReqBoardForArchiveForModify = {
                    idx: state.idx,
                    title: form_state.title,
                    ...(state.thumbnail.name ? { file_thumbnail: state.thumbnail } : {}),
                    ...(state.fileList.length > 0 ? { file: state.fileList } : {}),
                };

                if (state.fileList && state.fileList.length > 0) {
                    param.file = state.fileList;
                }

                const res = await apiService.archive.modify(param);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "저장이 완료되었습니다.";
                    state.isShowModal = true;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const isShowPreview = () => {
                state.isShowPreview = true;
                state.previewModalContent = `<img src="${form_state.thumbnail}" alt="">`;
            };

            return {
                state,
                form_state,
                fileRemove,
                downloadFile,
                closeModal,
                callBackModal,
                router,
                removeNewFile,
                removethumbnail,
                save,
                changethumbnail,
                handleFiles,
                header,
                CommonUtils,
                isShowPreview,
            };
        },
    };
</script>
<style scoped>
    .con_write .file_list {
        padding-left: 0px;
    }

    .news_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
    .con_write .file_wrap label {
        width: 100%;
    }

    .thumbnail_preview {
        max-height: 150px;
        min-height: 100px;
        max-width: 150px;
        min-width: 100px;
        border: 1px solid lightgray;
    }
    .thumbnail_preview img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .con_write .file_wrap .form_li_tit {
        display: flex;
        gap: 5px;
    }
    .con_write .file_list {
        gap: 5px;
        flex-direction: column;
    }
</style>
